import React from 'react'
import styles from '@/styles/finisherTheatrics.module.scss'
import type { FinisherId } from '@/types/finisher'

interface FinisherTheatricsProps {
  finisherId: FinisherId
  // Screen-Y ratio (0..1) to anchor the theatrics over the loser. Default 0.5.
  anchorYRatio?: number
}

// Per-finisher DOM theatrics layered over the shader VFX:
//   funny     → comic "BONK!" starburst bubble + halftone dot burst
//   animality → three diagonal claw rakes
//   brutality → none here (screenshake is applied to the scene container by
//               the host; the shader carries the impact)
const FinisherTheatrics: React.FC<FinisherTheatricsProps> = ({ finisherId, anchorYRatio = 0.5 }) => {
  if (finisherId === 'brutality') return null

  const top = `${anchorYRatio * 100}vh`

  return (
    <div className={styles.layer} data-testid='finisher-theatrics' data-finisher={finisherId}>
      <div style={{ position: 'absolute', top, left: '50%', transform: 'translate(-50%, -50%)' }}>
        {finisherId === 'funny' && (
          <>
            <div className={styles.halftone} />
            <div className={styles.bubble}>BONK!</div>
          </>
        )}
        {finisherId === 'animality' && (
          <div className={styles.claws}>
            <div className={styles.claw} />
            <div className={styles.claw} />
            <div className={styles.claw} />
          </div>
        )}
      </div>
    </div>
  )
}

export default FinisherTheatrics
